import { render, staticRenderFns } from "./OldPrivacyPolicy.vue?vue&type=template&id=1a80fc6e&"
import script from "./OldPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./OldPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./OldPrivacyPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports